import React, { useEffect, useState, useRef} from 'react' 
import Sobre from '../css/Contacto.Module.css'
import { useTranslation } from 'react-i18next';
import emailjs from '@emailjs/browser';
import { toast, ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import useScrollReveal from './hooks/useScrollReveal';
export function Contact() {
  const { t, i18n } = useTranslation();
  const [result, setResult] = React.useState("");
  const [Email, setEm] = useState('');
  useScrollReveal(true);
const form = useRef();
function handleDownload(e){
  e.preventDefault();
     toast.success(t('contactos.success'));

  emailjs.sendForm('service_dbs9l3l', 'template_0lb5xgs', form.current, {
    publicKey: 'RXwAqTYouJEJek7HF',
  })
  .then(
    () => {
      console.log('SUCCESS!');
    },
    (error) => {
      console.log('FAILED...', error.text);
    },
  );
}
  return (
    <div>
    <section className="contact_us">
        <div className="container">
          <div className="row">
            <div className="col-md-10 offset-md-1">
              <div className="contact_inner">
                <div className="row">
                  <div className="col-lg-10 col-md-7 col-7 form-container">
                    <div className="contact_form_inner">
                    <form className='contact_field' method='POST' ref={form} onSubmit={handleDownload}>
                        <h3 className='text-uppercase scroll-top'>{t('noticias.tituloPage')}</h3>
                        <p className='scroll-right'>{t('contactos.text')}</p>
                        <input type="text" className="form-control form-group scroll-bottom" name="from_name" placeholder={t('contactos.nome')} />
                        <input type="tel" className="form-control form-group scroll-bottom" name="from_phone" placeholder={t('contactos.telefone')} />
                        <input type="email" className="form-control form-group scroll-bottom" name="from_email" placeholder="Email"  />
                        <textarea className="form-control form-group scroll-bottom" name="from_message" placeholder={t('contactos.mensagem')} defaultValue={""} />
                        <button className="contact_form_submit scroll-bottom" type='submit'>{t('contactos.enviar')}</button>
                      </form>
                      <ToastContainer />
                    </div>
                  </div>
                </div>
                <div className="contact_info_sec scroll-top">
                  <h4>{t('contactos.infoconta')}</h4>
                  <div className='two-blocks'>
                  <div className="d-flex info_single align-items-center">
                    <i className="fa-solid fa-mobile-screen-button" />
                    <span>+34 696464669</span>
                  </div>
                  <div className="d-flex info_single align-items-center">
                    <i className="fas fa-envelope-open-text" />
                    <span>info@iberolec.com</span>
                  </div>
                  </div>
                  <div className="d-flex info_single align-items-center">
                    <i className="fas fa-map-marked-alt" />
                    <span>C. Murias, 27 C, &amp; {t('footer.cidade')}, {t('footer.pais')}</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="map_sec">
        <div className="container">
          <div className="row">
            <div className="col-md-10 offset-md-1">
              <div className="map_inner">
                <h4 className='scroll-top'>{t('footer.visitar')}</h4>
                <div className="map_bind scroll-bottom">
                <iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d1523.5937968560032!2d-3.754260124876775!3d40.26914436579339!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0xd418a97e52ca15f%3A0x9fa22e5c82e3515d!2s!5e0!3m2!1spt-BR!2spt!4v1625400000000!5m2!1spt-BR!2spt" width="100%" height={450} allowFullScreen aria-hidden="false" tabIndex={0} />
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

    </div>
  )
}

export default Contact